import type { EvalEvent, EvalEventType } from "@offsite/shared";

const TYPE_ICON: Record<EvalEventType, string> = {
  request_sent: "→",
  response_received: "←",
  parsed: "✓",
  saved: "✓",
  error: "✕",
};

const TYPE_LABEL: Record<EvalEventType, string> = {
  request_sent: "Request",
  response_received: "Response",
  parsed: "Parsed",
  saved: "Gespeichert",
  error: "Fehler",
};

function formatTime(ts: number): string {
  const d = new Date(ts);
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}

interface Props {
  events: EvalEvent[];
  /** Max number of events to show. Newest first. */
  max?: number;
  variant?: "compact" | "full";
}

export function EvalEventFeed({ events, max = 8, variant = "compact" }: Props) {
  // Newest first — backend returns oldest-first.
  const ordered = [...events].reverse().slice(0, max);

  return (
    <div className={`eval-event-feed${variant === "full" ? " is-full" : ""}`}>
      <header className="eval-event-feed-head">
        <span className="dot" aria-hidden="true" />
        Live · was die KI gerade tut
      </header>
      {ordered.length === 0 ? (
        <div className="eval-event eval-event-empty">
          <span>… noch keine Events</span>
        </div>
      ) : (
        <ul className="eval-event-list">
          {ordered.map((e) => (
            <li key={e.id} className={`eval-event is-${e.type.replace("_", "-")}`}>
              <span className="eval-event-time">{formatTime(e.ts)}</span>
              <span className="eval-event-icon" aria-hidden="true">
                {TYPE_ICON[e.type]}
              </span>
              <span className="eval-event-team">
                T{e.teamNumber}
                {e.teamName ? ` ${e.teamName}` : ""}
              </span>
              <span className="eval-event-type">{TYPE_LABEL[e.type]}</span>
              <span className="eval-event-msg">{e.message}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
